import { render, staticRenderFns } from "./UserUpdateDialogPersonalData.vue?vue&type=template&id=80e570dc&scoped=true"
import script from "./UserUpdateDialogPersonalData.vue?vue&type=script&lang=ts"
export * from "./UserUpdateDialogPersonalData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e570dc",
  null
  
)

export default component.exports